import { css } from "@emotion/react";
import Image from "next/image";
import { Body } from "@/components/Typography";
import { mq } from "@/constants/breakpoints";

interface ReviewBadgeHeroProps {
  imageSrc: string;
  text: string;
}

const ReviewBadgeHero = ({ imageSrc, text }: ReviewBadgeHeroProps) => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        white-space: nowrap;
        gap: 8px;
        padding: 4px 12px 4px 4px;
        background: linear-gradient(
          103.92deg,
          rgba(255, 255, 255, 0.1) -0.74%,
          rgba(190, 220, 255, 0.1) 99.87%
        );
        border-radius: 32px;
        border: 1px solid #ffffff1a;
        ${mq["xs"]} {
          flex-grow: unset;
        }
        ${mq["sm"]} {
          width: 100%;
          flex-grow: 1;
        }
        ${mq["sm"]} {
          width: auto;
          flex-grow: unset;
        }
      `}
    >
      <Image
        src={imageSrc}
        width={24}
        height={24}
        alt="Review Stars Count badge"
      />
      <Body
        css={css`
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          text-align: left;
          flex: 1;
          color: #fff;
        `}
      >
        {text}
      </Body>
    </div>
  );
};

export default ReviewBadgeHero;
